import * as fabric from 'office-ui-fabric-react';
import { Nav } from 'office-ui-fabric-react';
import React, { FC, useEffect } from 'react';
import { LocationStatus, LocationType } from '../../enums';

export interface ILocationItem {
    id: number;
    name: string | null;
    partOfLocationId: number | null;
    locationType: LocationType;
    locationStatus: LocationStatus;
    key: string | null;
    doorControllerKey: string | null;
    activeTicketPrintingTimeBeforeVisit: number | null;
    activeTicketPrintingTimeAfterVisit: number | null;
    isActiveTicketPrintingTimeBeforeVisitEnabled: boolean | null;
    isActiveTicketPrintingTimeAfterVisitEnabled: boolean | null;
    floor: number | null;
}

interface IProps {
    locations: ILocationItem[];
    onSelect: (locationKey: string | undefined) => void;
    onLoadSelectedId: number | null;
}

export const mapLocationToGroup = (location: ILocationItem, level: number): fabric.IGroup => {
    return {
        key: location.id.toString(),
        name: location.name ? location.name : '',
        count: 0,
        startIndex: 0,
        children: [],
        data: location.id,
        level: level,
        isCollapsed: false
    };
};
const mapLocationToNavElement = (x: ILocationItem, fullPath: number[]): fabric.INavLink => {
    const isExpanded = fullPath.some((e) => e === x.id);
    return {
        name: x.name ?? '',
        url: '',
        key: x.id.toString(),
        isExpanded: isExpanded
    };
};

const findFullPath = (selectedLocationId: number | undefined, locations: ILocationItem[], result: number[]) => {
    if (selectedLocationId === undefined || selectedLocationId === null) return result;
    const selectedLocation = locations.find((x) => x.id === selectedLocationId);

    if (selectedLocation.partOfLocationId === null) {
        result.push(selectedLocation.id);
        return result;
    } else {
        result.push(selectedLocation.id);
        const parentLocation = locations.find((x) => selectedLocation.partOfLocationId === x.id);
        if (parentLocation.partOfLocationId === null) {
            result.push(parentLocation.id);
            return result;
        } else {
            findFullPath(parentLocation.id, locations, result);
        }
    }
};

const createNav = (id: number | null, locations: ILocationItem[], fullPath: number[]): fabric.INavLink[] => {
    const result: fabric.INavLink[] = [];
    const nodeChildren = locations.filter((x) => x.partOfLocationId === id);

    nodeChildren.forEach((x) => result.push(mapLocationToNavElement(x, fullPath)));

    result.forEach((x) => {
        if (x.key) {
            x.links = createNav(parseInt(x.key), locations, fullPath);
        }
    });

    return result;
};

const LocationTree: FC<IProps> = ({ locations, onSelect, onLoadSelectedId }) => {
    const fullPath: number[] = [];
    findFullPath(onLoadSelectedId, locations, fullPath);

    const nav: fabric.INavLinkGroup[] = [
        {
            links: createNav(null, locations, fullPath)
        }
    ];

    useEffect(() => {}, []);

    return (
        <Nav
            groups={nav}
            onLinkClick={(ev?: React.MouseEvent<HTMLElement, MouseEvent> | undefined, item?: fabric.INavLink | undefined) => {
                if (item && item.key) {
                    onSelect(item.key);
                }
            }}
        />
    );
};

export default LocationTree;
